// extracted by mini-css-extract-plugin
export var contentContainer = "index-module--contentContainer--q10cp";
export var logo = "index-module--logo--60Vd8";
export var socialMediaContainer = "index-module--socialMediaContainer--7fzND";
export var socialMediaItem = "index-module--socialMediaItem--W0wq7";